import Http from "@/commons/Http";
import Utils from "@/utils/Utils";

const path = 'api/type-service';

export default {

    async getAll(){
        return Http.get(`${path}`);
    },

    async getAllActive(){
        return Http.get(`${path}/active`);
    },

    async save(dto, id = ''){
        return Http.post(`${path}/${id}`, dto);
    },

    async delete(id = ''){
        return Http.delete(`${path}/${id}`);
    },

    async getById(id){
        return Http.get(`${path}/${id}`);
    },

    async audit(sort, direction, page, size){
        const filters = {entity: "TypeService"};
        return Http.post(`${path}/audit?sort=${sort || 'ts.created'},${direction || 'asc'}&page=${page || 1}&size=${size || 10}`, {filters});
    },

    async pagination(sort, direction, page, size, filters = {}){
        return Http.post(`${path}/pagination?sort=${sort || 'ts.name'},${direction || 'asc'}&page=${page || 1}&size=${size || 10}`, {filters});
    },

    async searchByName(name) {
        if(Utils.isEmptyNullOrUndefined(name)) {
            return this.getAllActive();
        }
        return Http.get(`${path}/s/active/${name}/10`);
    },

    getTypeDiscount() {
        return [
            {id: 'VALUE', name: 'forms.type-service.type-discount-value'},
            {id: 'PERCENT', name: 'forms.type-service.type-discount-percent'},
        ]
    },

    typeBillingName(service){
        return this.$t(`forms.type-service.${service.typeBilling.toLowerCase()}`);
    },

}
